import firebase from '../../Firebase/FirebaseInit'
import router from '../../router/index.js'

export default {
  state: {
    project: null
  },
  mutations: {
    setProject (state, payload) {
      state.project = payload
      router.push('/project/' + payload.id)
    },
    setProjectTime1 (state, payload) {
      state.project = payload
      router.push('/projects')
    }
  },
  actions: {
    editProject ({dispatch, commit}, {project, file}) {
      commit('setLoading', true)
      commit('clearError')
    },
    updateProject ({commit}, payload) {
      firebase.firestore()
      .collection('projects')
      .doc(payload.id)
      .set({id: payload.id, title: payload.title, files: payload.files, image: payload.image, description: payload.description, startDate: payload.startDate, endDate: payload.endDate, members: payload.members, creator: payload.creator})
      .then((response) => {
        commit('setProject', payload)
        commit('setLoading', false)
      })
    },
    newFile ({dispatch, commit}, payload) {
      commit('setLoading', true)
      commit('clearError')
      if (payload[1] != null) {
        let path = 'project_file/' + payload[2] + Math.random() * 1000
        var storageref = firebase.storage().ref(path)
        storageref.put(payload[1]).then((response) => {
          storageref.getDownloadURL().then(function (url) {
            var taggy = payload[5]
            if (payload[5] === []) {
              taggy = undefined
            }
            var files = {
              fileURL: url,
              title: payload[3],
              tags: taggy
            }
            if (payload[2] === 0) {
              firebase.firestore().collection('users').doc(payload[4]).collection('files').add({file: files})
            }
            if (payload[2] !== 0) {
              payload[0].push(files)
              firebase.firestore().collection('projects').doc(payload[2]).update({files: payload[0]})
            }
          }).catch(function (error) {
            console.log(error)
            return
          })
        })
      }
    },
    UpdateMembers ({dispatch, commit}, payload) {
      commit('setLoading', true)
      commit('clearError')
      var id = payload[payload.length - 1]
      var length = payload[payload.length - 2]
      var newMembers = []
      for (var i = 0; i < payload.length - 2; i++) {
        newMembers.push(payload[i])
      }
      firebase.firestore().collection('projects').doc(id).update(
       {members: newMembers}
      )
      for (var j = newMembers.length - 1; j > newMembers.length - (length + 1); j--) {
        firebase.firestore()
        .collection('users')
        .doc(newMembers[j])
        .collection('projects')
        .add({
          projectID: id
        })
      }
    },
    readProjectNotification ({commit}, {project, user, notification}) {
      firebase.firestore()
      .collection('projects')
      .doc(project)
      .collection('notifications')
      .doc(notification)
      .update({
        'read': firebase.firestore.FieldValue.arrayUnion(user)
      })
    },
    CreateItem ({dispatch, commit}, payload) {
      commit('setLoading', true)
      commit('clearError')
      if (payload.type === 'meeting') {
        payload.members.push(payload.creator)
        payload.rsvp.push(payload.creator)
        firebase.firestore().collection('projects').doc(payload.projectID).collection(payload.type).add({
          title: payload.title,
          description: payload.description,
          startDate: payload.startDate,
          startTime: payload.startTime,
          members: payload.members,
          creator: payload.creator,
          repeat: payload.repeat,
          rsvp: payload.rsvp,
          no: payload.no,
          location: payload.location,
          callin: payload.callin
        }).then((docRef) => {
          firebase.firestore().collection('projects').doc(payload.projectID).collection('notifications').add({
            message: `A new ${payload.type} has been created: ${payload.title}.`,
            creator: payload.creator,
            type: payload.type,
            timestamp: new Date().getTime(),
            eventID: docRef.id,
            read: [payload.creator]
          })
        })

        // if (payload.repeat !== '') {
        //   if (this.project.endDate === 0) {

        //   }
        //   if (this.project.endDate !== 0) {
        //     var stop = this.project.endDate
        //     if (payload.repeat === 'day') {
        //       stop
        //     }
        //     if (payload.repeat === 'week') {
        //     }
        //     if (payload.repeat === 'month') {
        //       var payload2 = payload
        //       if (payload2.endDate.substring(5, 7) === '12') {
        //         payload2.endDate = Number(payload.endDate.substring(0, 4)) + '-01' + payload.endDate.substring(7)
        //         console.log(payload2.endDate)
        //       }
        //     }
        //     if (payload.repeat === 'year') {
        //     }
        //   }
        // }
      }
      if (payload.type === 'todo') {
        if (payload.members === []) {
          payload.members.push(payload.creator)
        }
        firebase.firestore().collection('projects').doc(payload.projectID).collection(payload.type).add({
          title: payload.title,
          description: payload.description,
          startDate: payload.startDate,
          startTime: payload.startTime,
          members: payload.members,
          creator: payload.creator,
          finish: false
        }).then((docRef) => {
          firebase.firestore().collection('projects').doc(payload.projectID).collection('notifications').add({
            message: `A new ${payload.type} has been created: ${payload.title}.`,
            creator: payload.creator,
            type: payload.type,
            timestamp: new Date().getTime(),
            eventID: docRef.id,
            read: [payload.creator]
          })
        })
      }
    },
    addContactProject ({commit, state}, {payload, memberID}) {
      firebase.firestore()
      .collection('projects')
      .doc(this.project.id)
      .set({
        members: firebase.firestore().collection('projects').doc(this.project.id).collection('members').push(payload.contactID)
      })
    },
    deleteMember ({commit}, {account, member}) {
      firebase.firestore()
      .collection('projects')
      .doc(this.project.id)
      .collection('members')
      .doc(member)
      .delete()
    },
    CreateProject ({dispatch, commit}, payload) {
      commit('setLoading', true)
      commit('clearError')
      var images = ['/static/img/images/proj_image1.jpg', '/static/img/images/proj_image2.jpg', '/static/img/images/proj_image3.jpg', '/static/img/images/proj_image4.jpg', '/static/img/images/proj_image5.jpg', '/static/img/images/proj_image6.jpg', '/static/img/images/proj_image7.jpg']
      var theImage = images[Math.floor(Math.random() * images.length)]
      payload.members.push(payload.creator.id)
      payload.image = theImage
      firebase.firestore().collection('projects').add({
        title: payload.title,
        description: payload.description,
        startDate: payload.startDate,
        endDate: payload.endDate,
        members: payload.members,
        creator: payload.creator,
        image: theImage,
        files: payload.files
      }).then((docRef) => {
        console.log('sever 2:' + docRef.id)
        firebase.firestore().collection('projects').doc(docRef.id).update({
          id: docRef.id
        })
        for (var i = 0; i < payload.members.length; i++) {
          firebase.firestore()
          .collection('users')
          .doc(payload.members[i])
          .collection('projects')
          .add({
            projectID: docRef.id
          })
        }
        commit('setProjectTime1', payload)
      })
    }
  },
  getters: {
    project (state) {
      return state.project
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/project/index.js